import { isNil } from "lodash";

export default (payments) => {
  if (isNil(payments)) return [];

  const paymentsToDisplay = payments.filter((payment) => {
    const isPaymentRetry = payment.reference_type === "RETRY_PAYMENT";
    const isPaymentUnsuccessful = !["succeeded", "refunded", "canceled"].includes(payment.status);
    const isPaymentCashOut = payment.reference_type === "TRIP_PAYMENT_CASH_OUT";
    return !((isPaymentRetry && isPaymentUnsuccessful) || isPaymentCashOut);
  });

  paymentsToDisplay.sort((payment) => (payment.status === "failed" ? -1 : 1));

  const successfulRetryPayment = paymentsToDisplay.find(
    (payment) => payment.reference_type === "RETRY_PAYMENT" && payment.status === "succeeded",
  );

  if (successfulRetryPayment) {
    for (let i = 0; i < paymentsToDisplay.length; i++) {
      const payment = paymentsToDisplay[i];
      if (payment.reference_type === "TRIP_PAYMENT") {
        payment.strikeThrough = true;
        const firstPayment = paymentsToDisplay[0];
        paymentsToDisplay[0] = payment;
        paymentsToDisplay[i] = firstPayment;
        break;
      }
    }
  }
  return paymentsToDisplay;
};
